export default function Events() {
    jQuery(document).ready(function($) {

        function disableScroll() {
            $("html,body").toggleClass("relative overflow-hidden");
        }

        function toggleModal() {
            $(".event-poster-modal").toggleClass("hidden open");
        }

        function toggleModalOverlay() {
            $('.modal-overlay').toggleClass('bg-opacity-0 bg-opacity-80');
        }

        function toggleModalInner() {
            $('.modal-inner').toggleClass('opacity-0 opacity-100');
        }

        if($(".event-poster-modal").length) {
            $(".event-poster-expand").on("click", function() {
                disableScroll();
                toggleModal();
                setTimeout(toggleModalOverlay, 100);
                setTimeout(toggleModalInner, 200);
            })

            $(".event-poster-modal").on("click", function(e) {
                if(!$(e.target).closest("img").length) {
                    setTimeout(disableScroll, 500);
                    setTimeout(toggleModal, 500);
                    setTimeout(toggleModalOverlay, 300);
                    setTimeout(toggleModalInner, 200);
                }
            })
        }
    })
    
}